const rootArea = "/classifications";

export const classificationsGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (classificationTypeCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${classificationTypeCode}/read`,
		remove: `${baseArea}${rootArea}/${classificationTypeCode}/remove`,
		add: `${baseArea}${rootArea}/${classificationTypeCode}/add`
	})
});